import React from 'react';

const ImprintEn = () => {
  return (
    <div
      style={{
        padding: '48px',
        lineHeight: '1.6',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h1>Imprint (Legal Notice)</h1>

      <section>
        <h2>
          Information in Accordance with Section 5 of the German Telemedia Act
          (TMG)
        </h2>
        <p>
          <strong>Responsible for Content:</strong>
          <br />
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Address: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth,
          Israel
          <br />
          Email: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website:{' '}
          <a
            href="https://fotogram.technology"
            target="_blank"
            rel="noopener noreferrer"
          >
            fotogram.technology
          </a>
        </p>
      </section>

      <section>
        <h2>Hosting</h2>
        <p>
          The website and all data are hosted on servers located in Germany.
          These servers comply with the highest security standards and meet all
          requirements of the General Data Protection Regulation (GDPR).
        </p>
      </section>

      <section>
        <h2>VAT Identification Number</h2>
        <p>
          Fotogram Technology is headquartered in Israel and is not subject to
          VAT in Germany. Therefore, no VAT identification number is provided.
        </p>
      </section>

      <section>
        <h2>Disclaimer (Liability Notice)</h2>

        <h3>1. Content Liability</h3>
        <p>
          The content of this website has been created with the utmost care.
          However, we cannot guarantee the accuracy, completeness, or timeliness
          of the content. As a service provider, we are responsible for our own
          content on these pages under general laws in accordance with Section
          7(1) TMG. However, under Sections 8 to 10 TMG, we are not obligated to
          monitor third-party information transmitted or stored on our website
          or to investigate circumstances that indicate illegal activity.
        </p>
        <p>
          Obligations to remove or block the use of information under general
          laws remain unaffected. However, liability in this regard is only
          possible from the point in time when we become aware of a specific
          legal violation. Upon becoming aware of such violations, we will
          remove the respective content immediately.
        </p>

        <h3>2. Liability for Links</h3>
        <p>
          Our website contains links to external third-party websites over whose
          content we have no control. Therefore, we cannot assume any liability
          for this third-party content. The respective provider or operator of
          the linked sites is always responsible for their content.
        </p>
        <p>
          The linked pages were checked for possible legal violations at the
          time of linking, and no illegal content was identifiable. However,
          continuous monitoring of the content of linked pages is not feasible
          without specific indications of a legal violation. Upon becoming aware
          of legal violations, we will remove such links immediately.
        </p>

        <h3>3. Copyright</h3>
        <p>
          The content and works on this website created by the site operators
          are subject to German copyright law. The reproduction, editing,
          distribution, and any form of use beyond what is permitted under
          copyright law require prior written consent from the respective author
          or creator. Downloads and copies of this website are permitted for
          private, non-commercial use only.
        </p>
        <p>
          Where content on this website has not been created by the operator,
          third-party copyrights are respected. Such content is specifically
          marked. If you become aware of a copyright violation, please notify
          us. Upon becoming aware of legal violations, we will remove such
          content immediately.
        </p>
      </section>

      <section>
        <h2>Contact Information</h2>
        <p>
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Address: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth,
          Israel
          <br />
          Email: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website:{' '}
          <a
            href="https://fotogram.technology"
            target="_blank"
            rel="noopener noreferrer"
          >
            fotogram.technology
          </a>
        </p>
      </section>

      <section>
        <h2>Consumer Dispute Resolution</h2>
        <p>
          Fotogram Technology does not participate in dispute resolution
          procedures before a consumer arbitration board and is not obligated to
          do so.
        </p>
      </section>
    </div>
  );
};

export default ImprintEn;
